import { createPanelDataBridge, type PanelDataBridge } from './createPanelDataBridge.ts';

export type SeededRovoPromptBridgeData = {
	contentId: string | undefined;
	/** The prompt the panel should open Rovo with, or null when it should open on connections. */
	prompt: string | null;
};

export const initialSeededRovoPromptBridgeData: SeededRovoPromptBridgeData = {
	contentId: undefined,
	prompt: null,
};

/**
 * Carries a prompt the preview panel should open its Rovo chat with, for callers outside the
 * panel's tree — today only the byline popup's share-context modal.
 *
 * A bridge rather than a prop because preview-panels treats a repeat `open()` with the same panel
 * id as a no-op, so the `content` closure can never be handed fresh props once the panel is open.
 * `useTeamworkGraphPreviewPanelMode` clears it on leaving Rovo and on unmount, so a later open
 * does not land back in a seeded chat.
 *
 * Only ever written from an event handler, so nothing publishes during SSR.
 */
const bridge: PanelDataBridge<SeededRovoPromptBridgeData> = createPanelDataBridge(
	initialSeededRovoPromptBridgeData,
);

export const publishSeededRovoPrompt: typeof bridge.publish = bridge.publish;
export const clearSeededRovoPrompt: typeof bridge.clear = bridge.clear;
export const useSeededRovoPrompt: typeof bridge.useValue = bridge.useValue;
export const clearSeededRovoPromptForTesting: typeof bridge.clearForTesting =
	bridge.clearForTesting;
